import {useTranslation} from 'react-i18next'

import {IconCopy, IconMail, IconMobile, IconPhone} from '@sdox/icons'
import {CopyButton, ContactInfoRow, LinkButton} from '@sdox/ui'
import {useCurrentContactPerson} from '@sdox/api'

import {AddressRow} from './AddressRow'

export const ContactInfoRows = () => {
  const {t} = useTranslation()
  const contactPerson = useCurrentContactPerson()
  const {email, displayEmail, phone, mobile} = contactPerson ?? {}
  const shownEmail = displayEmail || email

  return (
    <div className={'mt-spacing-32 hidden px-spacing-32 md:block'}>
      {shownEmail ? (
        <ContactInfoRow
          leading={<IconMail/>}
          trailing={(
            <>
              <CopyButton
                copyContent={shownEmail}
                size={'small'}
                mboAttrs={{prefix: 'ContactPersonDialog', piece: 'EMailCopy'}}
                aria-label={t('common:copy')}
                title={t('common:copy')}
                variant={'flat'}
              />
              <LinkButton
                href={`mailto:${shownEmail}`}
                size={'small'}
                leading={<IconMail/>}
                mboAttrs={{prefix: 'ContactPersonDialog', piece: 'EMailOpen'}}
                aria-label={t('common:openInMail')}
                title={t('common:openInMail')}
                variant={'flat'}
              />
            </>
          )}
        >
          {shownEmail}
        </ContactInfoRow>
      ) : null}
      {phone ? (
        <ContactInfoRow
          leading={<IconPhone/>}
          trailing={(
            <>
              <CopyButton
                copyContent={phone}
                size={'small'}
                mboAttrs={{prefix: 'ContactPersonDialog', piece: 'PhoneCopy'}}
                aria-label={t('common:copy')}
                title={t('common:copy')}
                variant={'flat'}
              />
              <LinkButton
                href={`tel:${phone}`}
                size={'small'}
                leading={<IconPhone/>}
                mboAttrs={{prefix: 'ContactPersonDialog', piece: 'PhoneOpen'}}
                aria-label={t('common:call')}
                title={t('common:call')}
                variant={'flat'}
              />
            </>
          )}
        >
          {phone}
        </ContactInfoRow>
      ) : null}
      {mobile ? (
        <ContactInfoRow
          leading={<IconMobile/>}
          trailing={(
            <>
              <CopyButton
                copyContent={mobile}
                size={'small'}
                mboAttrs={{prefix: 'ContactPersonDialog', piece: 'MobileCopy'}}
                aria-label={t('common:copy')}
                title={t('common:copy')}
                variant={'flat'}
              />
              <LinkButton
                href={`tel:${mobile}`}
                size={'small'}
                leading={<IconPhone/>}
                mboAttrs={{prefix: 'ContactPersonDialog', piece: 'MobileOpen'}}
                aria-label={t('common:call')}
                title={t('common:call')}
                variant={'flat'}
              />
            </>
          )}
        >
          {mobile}
        </ContactInfoRow>
      ) : null}
      <AddressRow />
    </div>
  )
}
